import React, { useState, useEffect } from 'react';
import axios from 'axios';
import apiUrl from "../../apiUrlConstant";

const DynamicForm = ({initialColumns, initialRows , ths}) => {
  
  const [columns, setColumns] = useState(initialColumns || []);
  const [rows, setRows] = useState(initialRows || []);
  const [loading, setLoading] = useState(true);
  const [popupalertMessage, setpopupalertMessage] = useState(false);
  const [popupMessageContent, setpopupMessageContent] = useState("123");

  const [textContent, setTextContent] = useState("");

  const redirectToClose = () => {
    setpopupMessageContent("");
    setpopupalertMessage(false);
    ths.setState({ viewModal : false })
  };

  // Fetch data on component mount
  useEffect(() => {
    if (initialColumns && initialRows) {
        setColumns(initialColumns);
        setRows(initialRows);
        setLoading(false);
      }
  }, [initialColumns, initialRows]);

  // Handle input change for editable fields
  const handleInputChange = (index, key, value) => {
    const updatedRows = [...rows];

    if(key=='reimbursementDeduction'){
      if(key=='reimbursementDeduction' && !isNaN(value)){
        let finalNetAmount =  updatedRows[index]['month2NetAmt']-value;
        updatedRows[index]['finalNetAmount'] = finalNetAmount;
      }else{
        updatedRows[index]['finalNetAmount']= updatedRows[index]['month2NetAmt'];
        value = 0;
      }
    }

    updatedRows[index][key] = value;
    setTextContent(value);
    setRows(updatedRows);
  };

  const handleFocus = (rowIndex, key) => {
    setTextContent(rows[rowIndex][key]);
  };

  const handleSave = (method) => {

    axios
      .post(`${apiUrl.apiUrl.url}/finance-report/payment-update?date=${ths.state.formConfig.financialYearOne}`, { 'formData' : rows })
      .then(function (response) {
        if (response.data.success) {
            var headers = {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("TOKEN"),
            };
            var prm = Object.entries(ths.state.initialValues)
              .map(([key, val]) => `${key}=${val}`)
              .join("&");

            // fetch(
            // `${apiUrl.apiUrl.url}/finance-report/payment-download?` + prm,
            // { headers }
            // )
            // .then((response) => {
            //     return response.json();
            // })
            // .then((data) => {
            //     ths.setState({ exportBtn: true, viewModal: false });
            //     window.location.href = `${apiUrl.apiUrl.url + '/lease-report/download-file?path=' + data.filename}`;
            // })
            // .catch((error) => {
            //     console.log(error);
            // });

            axios({
              method: "post",
              url: `${apiUrl.apiUrl.url}/finance-report/payment-download?` + prm,
              //data: { columnsList: columnsList }
            }).then(function (response) {
              if(method == "save") {
                ths.setState({ exportBtn: false, viewModal: false });
              }else{
                ths.setState({ exportBtn: true, viewModal: false });
                window.location.href = `${apiUrl.apiUrl.url + '/lease-report/download-file?path=' + response.data}`;
              }
            });
        }
      });
  };

  return (
    <div>
      <div className="table-overflow-cls">      
        <table border="1" width="100%">
          <thead>
            <tr>
              {columns.map((column, index) => (
                <th key={column.key} className={column.is_highlighted == true ? "highlightedTh" : "not"}>
                  <p className="m-0">
                    {column.label}
                  </p>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((column, index) => (
                  <td key={column.key}>
                    {column.editable ? (
                      <input
                        type="text"
                        value={row[column.key] || ""}
                        onChange={(e) =>
                          handleInputChange(rowIndex, column.key, e.target.value)
                        }
                        style={{ width: '100%' }}
                        onFocus={() => handleFocus(rowIndex, column.key)} // Custom onFocus callback
                      />
                    ) : (
                      <p>{row[column.key] || ""}</p>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
       
      </div>
      <div className="row m-0 mt-5 align-items-center">
        <div className="col-sm-9 ps-0">
          <p className="m-0">{textContent}</p>
        </div>
        <div className="col-sm-3 pe-0 text-end">
          <div className="button_group d-flex gap-3 justify-content-end">
              <button className="add_button" onClick={ () => { handleSave('save'); }  }>Save</button>
              <button className="update_button" onClick={ () => { handleSave('save_n_download'); }  }>Save & Download</button>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default DynamicForm;
